// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__o3c7J","title":"styles_title__R3L-Q","description":"styles_description__jRx7R"};